import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column fill-height justify-start align-center text-white" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "LLM Bots Logo",
    src: _imports_0,
    width: "360"
  }),
  /*#__PURE__*/_createElementVNode("h1", { class: "text-h4 mb-4" }, [
    /*#__PURE__*/_createElementVNode("i", null, "LLM Bot Factory")
  ]),
  /*#__PURE__*/_createElementVNode("h4", { class: "subheading" }, " Grow and build your agent today! "),
  /*#__PURE__*/_createElementVNode("div", { class: "mt-14" }, " Produced by R4HS Inc. (株式会社イワテシガ). ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_parallax = _resolveComponent("v-parallax")!

  return (_openBlock(), _createBlock(_component_v_parallax, {
    src: require('@/assets/parallax2.jpg')
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["src"]))
}